

import React, { useState, useEffect } from "react";
import axios from "axios";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import CummulativeBox from "./cummulationBox";
import productImg from "../../Assets/Images/product.png"
import avaiProduct from "../../Assets/Images/total-product-1.png"
import inactProduct from "../../Assets/Images/product-inactive-1.png"
import locProduct from "../../Assets/Images/product-loc-1.png"
import { formatCurrencyValue } from "../../Services/Api";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import { FaHandHoldingUsd, FaTimesCircle, FaClipboardList, FaShippingFast, FaUserPlus, FaShoppingCart } from "react-icons/fa";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import CustomBtnLogo from "../../Components/UI-Controls/Buttons/BtnLogo";
import syncIcon from "../../Assets/sync.png"
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";

import "./style.css";

export default function OnlineInv() {
    const [inventory, setInventory] = useState([]);
    const [filteredInventory, setFilteredInventory] = useState([]);
    const [isSyncing, setIsSyncing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [cummulations, setCummulations] = useState(
        {
            totalProducts: 0,
            availableProducts: 0,
            reservedProducts: 0,
            totalSelling: 0,
            activeProductsCount: 0,
            inactiveProductsCount: 0
        }
    )

    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
            },
        },
    };

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        setOpenDropdownId(null); // Close dropdown on action
        // Add action logic here
    };

    const OrdersColumns = [
        {
            name: (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={(e) => console.log("All selected:", e.target.checked)}
                />
            ),
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="20px" height="20px" />
                ) : (
                    <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        onChange={(e) => console.log("Selected:", row, e.target.checked)}
                    />
                ),
            ignoreRowClick: true,
            width: "50px",
        },
        {
            name: "Product Name",
            selector: (row) => row.product_name,
            minWidth: "300px",
            // maxWidth: "450px",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="300px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div style={{
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textAlign:"start"
                    }}>
                        {row.product_name}
                    </div>
                ),
        },
        {
            name: "SKU",
            selector: (row) => row.sku,
            hide: "sm", // Hide on small screens
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div style={{
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                    }}>
                        {row.sku}
                    </div>
                ),
            minWidth: "200px",
            maxWidth: "250px",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            hide: "md", // Hide on medium and smaller screens
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div style={{
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                    }}>
                        {row.category}
                    </div>
                ),
            minWidth: "200px",
            maxWidth: "250px",
        },
        {
            name: "Regular Price",
            selector: (row) => row.regular_price,
            hide: "sm", // Hide on small screens
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div style={{
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                    }}>
                        ${formatCurrencyValue(row.regular_price)}
                    </div>
                ),
            minWidth: "60px",
            maxWidth: "160px",
        },
        {
            name: "Sale Price",
            selector: (row) => row.sale_price,
            hide: "sm", // Hide on small screens
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div style={{
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                    }}>
                        ${formatCurrencyValue(row.sale_price)}
                    </div>
                ),
            minWidth: "60px",
            maxWidth: "160px",
        },
        {
            name: "Available",
            selector: (row) => row.available,
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (() => {
                    let textColor = "#36454F";
                    let backgroundColor = "transparent";

                    if (row.available <= 0) {
                        textColor = "#F08F9F";
                        backgroundColor = "#F08F9F10";
                    }

                    return (
                        <div
                            style={{
                                color: textColor,
                                backgroundColor: backgroundColor,
                                padding: "5px 10px",
                                borderRadius: "5px",
                                boxSizing: "border-box",
                                display: "inline-block",
                                whiteSpace: "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                textAlign: "center"
                            }}
                        >
                            {row.available}
                        </div>
                    );
                })(),
            minWidth: "60px",
            maxWidth: "160px",
        },
        {
            name: "Stock",
            selector: (row) => row.stock_status,
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
                ) : (() => {
                    let textColor;
                    let backgroundColor;
                    let stockLabel;

                    const stockStatus = row.stock_status;
                    const quantity = row.available ?? 0;
                    const effectiveStatus = quantity <= 0 ? "outStock" : stockStatus;

                    switch (effectiveStatus) {
                        case "inStock":
                            textColor = "#5285B4";
                            backgroundColor = "#5285B410";
                            stockLabel = "In Stock";
                            break;
                        case "outStock":
                            textColor = "#F08F9F";
                            backgroundColor = "#F08F9F10";
                            stockLabel = "Out of Stock";
                            break;
                        case "lowStock":
                            textColor = "#F4B074";
                            backgroundColor = "#F4B07410";
                            stockLabel = "Low Stock";
                            break;
                        default:
                            textColor = "#36454F";
                            backgroundColor = "transparent";
                            stockLabel = stockStatus || "Undefined";
                    }

                    return (
                        <div
                            style={{
                                color: textColor,
                                backgroundColor: backgroundColor,
                                padding: "5px 10px",
                                borderRadius: "5px",
                                boxSizing: "border-box",
                                display: "inline-block",
                                fontWeight: 600,
                                whiteSpace: "normal",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                            }}
                        >
                            {stockLabel}
                        </div>
                    );
                })(),
            minWidth: "120px",
            maxWidth: "200px",
        }
    ];



    async function runSyncJobs() {
        try {
            const response = await axios.get('https://syncinventory.myfurnituremecca.com/api/v1/trigger/run-sync-jobs');

            // You can check for a successful response if needed
            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error running sync jobs:', error.message);
            return false;
        }
    }
    async function fetchData() {
        try {
            const response = await axios.get(
                "https://syncinventory.myfurnituremecca.com/api/v1/product-inventory/get-online-inventory"
            );

            const data = response?.data.data || [];
            const totalPro = response?.data?.summary?.totalProducts;
            const activePro = response?.data?.summary?.activeProductsCount;
            const inActivePro = response?.data?.summary?.inactiveProductsCount;

            setInventory(data);
            setFilteredInventory(data);

            // const cummulations = data.reduce(
            //     (acc, item) => {
            //         acc.totalProducts += 1;
            //         acc.availableProducts += Number(item.available) || 0;
            //         acc.reservedProducts += Number(item.reserved) || 0;
            //         acc.totalSelling += Number(item.selling_price) || 0;

            //         if (item.stock_status === "inStock") {
            //             acc.activeProductsCount += 1;
            //         } else {
            //             acc.inactiveProductsCount += 1;
            //         }

            //         return acc;
            //     },
            //     {
            //         totalProducts: 0,
            //         availableProducts: 0,
            //         reservedProducts: 0,
            //         totalSelling: 0,
            //         activeProductsCount: 0,
            //         inactiveProductsCount: 0,
            //     }
            // );

            setCummulations({
                totalProducts: totalPro,
                availableProducts: 0,
                reservedProducts: 0,
                totalSelling: 0,
                activeProductsCount: activePro,
                inactiveProductsCount: inActivePro
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);


    const rowsPerPage = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(inventory.length / rowsPerPage);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const paginatedData = filteredInventory.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );



    const placeholderRows = Array(7)
        .fill({ uid: "", name: "", image: "" })
        .map((row, index) => ({ ...row, uid: `placeholder-${index}` }));
    const displayedData = loading ? placeholderRows : paginatedData;

    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filtersModified, setFiltersModified] = useState(false);
    const [productName, setProductName] = useState("");
    const [productSku, setProductSku] = useState("");
    const [productId, setProductId] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [selectedStockStatus, setSelectedStockStatus] = useState("");


    const handleFilterChange = (value, fieldName) => {
        if (fieldName === "productName") {
            setProductName(value);
            setSearchTerm(value);

        } else if (fieldName === "productSku") {
            setProductSku(value);
            setSearchTerm(value);
        } else if (fieldName === "productCategory") {
            setCategoryId(value);
            setSearchTerm(value);
        } else if (fieldName === "productId") {
            setProductId(value);
            setSearchTerm(value); // optional: if you want ID search too
        } else if (fieldName === "stock") {
            setSelectedStockStatus(value); // ← add this line
            console.log(selectedStockStatus)

        }

        setFiltersModified(true);
        setFiltersApplied(true);
    };


    const handleSearch = (searchTerm) => {
        const lowerSearch = searchTerm.toLowerCase();

        const filtered = inventory.filter(item =>
            item.product_name?.toLowerCase().includes(lowerSearch) ||
            item.sku?.toLowerCase().includes(lowerSearch) ||
            item.uid?.toString().includes(lowerSearch) ||
            item.category?.toString().includes(searchTerm.toLowerCase())
        );

        setFilteredInventory(filtered);
        setCurrentPage(1); // Reset to first page after filtering
    };


    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const lowerSearch = searchTerm.toLowerCase();
        const filtered = inventory.filter((item) => {
            const matchesSearch =
                item.product_name?.toLowerCase().includes(lowerSearch) ||
                item.sku?.toLowerCase().includes(lowerSearch) ||
                item.uid?.toString().includes(lowerSearch) ||
                item.category?.toString().includes(lowerSearch);

            const matchesStock =
                selectedStockStatus === "" || item.stock_status === selectedStockStatus;

            return matchesSearch && matchesStock;
        });

        setFilteredInventory(filtered);
        setCurrentPage(1);
    }, [searchTerm, selectedStockStatus, inventory]);



    const handleResetFilters = () => {
        setProductName("");
        setProductId("");
        setProductSku("");
        setCategoryId("");
        setSearchTerm("");
        setFiltersApplied(false);
        setSelectedStockStatus("");
    };

    const productStockOptions = [
        { value: "inStock", label: "In Stock" },
        { value: "outStock", label: "Out of Stock" },
    ];
    return (
        <>
            <div className="inventory_tab">
                <div className="inventory_tab_cummulations">
                    <CummulativeBox name={"Total"} name2={"Products"} value={formatCurrencyValue(cummulations.totalProducts)} unit={"Products"} img={productImg} />
                    <CummulativeBox name={"In Stock"} name2={"Products"} value={formatCurrencyValue(cummulations.activeProductsCount)} unit={"Products"} img={avaiProduct} />
                    <CummulativeBox name={"Out of Stock"} name2={"Products"} value={formatCurrencyValue(cummulations.inactiveProductsCount)} unit={"Products"} img={inactProduct} />
                    <CummulativeBox name={"Active"} name2={"Locations"} value={"9"} unit={"Locations"} img={locProduct} />
                </div>

                <div style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "10px 0"
                }} className="sectionall_1">
                    <div
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <SearchBar onSearch={handleSearch} icon={searchIcon} />
                    </div>
                    <CustomBtnLogo
                        image={syncIcon}
                        label="Sync Inventory"
                        withIcon={true}
                        iconType="import"
                        type="button"
                        style={{
                            padding: "5px 5px",
                            marginRight: "20px"
                        }}
                        onClick={async () => {
                            setIsSyncing(true)
                            const success = await runSyncJobs();
                            if (success) {
                                console.log("Inventory synced successfully.");
                                setIsSyncing(false)
                                fetchData()
                            } else {
                                console.log("Failed to sync inventory.");
                                setIsSyncing(false)
                            }
                        }}
                    />
                </div>

                <div className="Filters-Section" style={{ width: "100%", marginLeft: 0, overflow: "visible" }}>
                    <Accordion allowZeroExpanded className="accordion" style={{ overflow: "visible" }}>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton>Filters</AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                {/* First Row: Labels */}
                                <div className="filter-row-01">
                                    {/* <div className="filter-label">Product Name</div> */}
                                    <div className="filter-label">Product SKU</div>
                                    <div className="filter-label">Product Category</div>
                                    <div className="filter-label">Product ID</div>
                                    <div className="filter-label">Stock Status</div>
                                </div>

                                {/* Second Row: React Select Fields */}
                                <div className="filter-row-02">
                                    {/* <InputField
                                        value={productName}
                                        name="productName"
                                        onChange={(e) =>
                                            handleFilterChange(e.target.value, "productName")
                                        }
                                        placeholder="Product Name"
                                    /> */}
                                    <InputField
                                        value={productSku}
                                        name="productSKU"
                                        onChange={(e) =>
                                            handleFilterChange(e.target.value, "productSku")
                                        }
                                        placeholder="Product SKU"
                                    />
                                    <InputField
                                        value={categoryId}
                                        name="productCategory"
                                        onChange={(e) =>
                                            handleFilterChange(e.target.value, "productCategory")
                                        }
                                        placeholder="Product Category ID"
                                    />
                                    <InputField
                                        value={productId}
                                        name="productID"
                                        onChange={(e) =>
                                            handleFilterChange(e.target.value, "productId")
                                        }
                                        placeholder="Product ID"
                                    />
                                    <div className="custom-dropdown-wrapper-Filter">
                                        <CustomDropdown
                                            options={productStockOptions}
                                            selectedOption={
                                                productStockOptions.find(
                                                    (option) => option.value === selectedStockStatus
                                                )?.label || "Select Status"
                                            }
                                            handleOptionChange={(value) =>
                                                handleFilterChange(value, "stock")
                                            }
                                            dropdownWidth={'100%'}
                                            dropdownMarginBottom="13px"
                                            backgroundColor="var(--third-layer-bg)"
                                            optionsWidth={'100%'}
                                            optionsBackgroundColor="var(--third-layer-bg)"
                                            optionsHeight={"auto"}
                                            dropdownSelectedStyle="7px"
                                        />
                                    </div>
                                </div>


                                {/* Fifth Row: Apply Filters Button */}
                                <div className="filter-row-04">
                                    {filtersApplied && (
                                        <CustomBtn
                                            label="Reset"
                                            withIcon={true}
                                            iconType="reset"
                                            className="ResetBtn-OrderPage"
                                            onClick={handleResetFilters}
                                            type="button"
                                        />
                                    )}
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                </div>


                <div className="Orders-Table-Data" style={{ width: "100%", marginLeft: "0" }}>
                    <div>
                        <DataTable
                            columns={OrdersColumns}
                            data={displayedData}
                            customStyles={customStyles}
                            // progressPending={loading}
                            persistTableHead
                            highlightOnHover
                            striped
                        />
                        <Pagination
                            activePageIndex={currentPage}
                            totalPages={totalPages}
                            onPrevPage={handlePrevPage}
                            onNextPage={handleNextPage}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>

            </div>
            {isSyncing && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Syncing Products Inventory..."} />
                </div>
            </div>}

        </>
    );
}
